import { useMemo } from 'react';

import { DataTable } from 'components/DataTable';
import { SiteState } from 'data/__generated__';

import {
    getEmbeddedSitesColumns,
    type EmbeddedSiteRow,
    type EmbeddedSitesFilterInput,
} from 'pages/Sites/constants/embeddedSitesColumns';

const defaultFilters: EmbeddedSitesFilterInput = {
    searchValue: '',
    state: [SiteState.Regular],
    type: [],
    deliveryType: [],
};

// Client-side sites DataTable embedded in a details page (organization or totem). Data is already fetched by the
// parent, so it filters/sorts in-memory. Active sites are shown by default; the "Statut" chip clears the filter.
export const EmbeddedSitesTable = ({
    sites,
    showTotemColumn = false,
    emptyMessage = 'Aucun site',
}: {
    sites: EmbeddedSiteRow[];
    showTotemColumn?: boolean;
    emptyMessage?: string;
}) => {
    const columns = useMemo(() => getEmbeddedSitesColumns({ showTotemColumn }), [showTotemColumn]);
    // Grow with the number of sites but cap it so the section stays compact.
    const tableHeight = Math.min(600, 200 + sites.length * 48);

    return (
        <div style={{ height: tableHeight }} className="flex w-full flex-col overflow-hidden">
            <DataTable<EmbeddedSiteRow, EmbeddedSitesFilterInput>
                columns={columns}
                data={sites}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/site/${row._id}`}
                defaultFilters={defaultFilters}
                searchPlaceholder="Nom du site…"
                searchFilterKey="searchValue"
                autoFocusSearch={false}
                disableUrlSync
                emptyMessage={emptyMessage}
            />
        </div>
    );
};
